// extracted by mini-css-extract-plugin
export default {"hr":"_tGXd"};